import { render, staticRenderFns } from "./AuthorLeft.vue?vue&type=template&id=06a279b8&scoped=true"
import script from "./AuthorLeft.vue?vue&type=script&lang=js"
export * from "./AuthorLeft.vue?vue&type=script&lang=js"
import style0 from "./AuthorLeft.vue?vue&type=style&index=0&id=06a279b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a279b8",
  null
  
)

export default component.exports